<div class="filter-section-chart" #dataLoading="appIsLoading" [appIsLoading]="loadingService.isLoading(this, 'performance')">
    <div *ngIf="isPromotionStarted && mytarget?.targets">
        <cs-performance-details [achieved]="mytarget.achieved" [targets]="mytarget?.targets" [endDate]="mytarget.endDate"
            [units]="mytarget.unit" [minTarget]="minTarget" [maxTarget]="maxTarget" [promotionName]="mytarget.name"
            [isPromotionStarted]="isPromotionStarted" [isPromotionEnded]="isPromotionEnded" [isMultiple]="isMultiple"
            [startDate]="mytarget.startDate" [redirectionLink]="payload.redirectionLink">
        </cs-performance-details>
    </div>
    <ng-template *ngIf="!dataLoading.appIsLoading && mytarget?.targets">{{'MyPerformance.NoTargets' | translate}}</ng-template>
</div>